module.exports = __webpack_public_path__ + "img/menu-off_04.5c5247fc.png";